import MapperBase from './MapperBase.js';

class RankingStatsMapper extends MapperBase {
    constructor(rankingParametersMapper, silent, fallback, stringifier, limitProperties, allowNullKeys) {
        super(silent, fallback);

        if (typeof(stringifier) === 'undefined') {
            // Object.prototype.toString.call(key); 
            // key.toString();
            stringifier = (key) => `${key}`;
        }
        else if (typeof(stringifier) !== 'function') {
            throw new TypeError('stringifier must be an function which will convert mixed type values to strings');
        }
        if (typeof(limitProperties) !== 'undefined' && !(limitProperties instanceof Array)) {
            throw new TypeError('limitProperties must be an array or undefined');
        }

        if (typeof(rankingParametersMapper) !== 'undefined' && !(rankingParametersMapper instanceof MapperBase)) {
            throw new TypeError('rankingParametersMapper must be an instance of MapperBase class');
        }

        this.stringifier = stringifier;
        this.limitProperties = limitProperties;
        this.rankingParametersMapper = rankingParametersMapper;
        this.allowNullKeys = !!allowNullKeys;
    }

    mapSingle(item) {
        const out = {};
        const {scope, parameters} = item;
        let itemOut = out;
        let itemPrev = out;
        let scopeValue = this.stringifier(typeof(item));
        
        for (const scopeKey in scope) {
            if (!Object.hasOwnProperty.call(scope, scopeKey) || (!this.allowNullKeys && scope[scopeKey] === null)) {
                continue;                    
            }

            if (this.limitProperties && !this.limitProperties.includes(scopeKey)) {
                continue;
            }

            scopeValue = this.stringifier(scope[scopeKey]);

            if (!Object.hasOwnProperty.call(itemOut, scopeValue)) {
                itemOut[scopeValue] = {};
            }

            itemPrev = itemOut;
            itemOut = itemOut[scopeValue];
        }

        if (this.rankingParametersMapper) {
            itemPrev[scopeValue] = this.rankingParametersMapper.mapCollection(parameters);
        }
        else {
            itemPrev[scopeValue] = parameters;
        }

        return out;
    }

    mapArray(array) {
        let out = {};

        for (let i = 0; i < array.length; i++) {
            try {
                out = Object.assign(out, this.map(array[i]));
            } catch (error) {
                this.handleMappingError(error, out, array[i], i);
            }
        }

        return out;
    }

    mapGenerator(generator) {
        let out = {};

        for (const item of generator) {
            try {
                out = Object.assign(out, this.map(item));
            } catch (error) {
                this.handleMappingError(error, out, item);
            }
        }

        return out;
    }

    mapObject(object) {
        let out = {};

        for (const key in object) {
            
            if (object.hasOwnProperty(key)) {
                try {
                    out = Object.assign(out, this.map(object[key]));
                } catch (error) {
                    this.handleMappingError(error, out, object[key], key);
                }
            }
        }

        return out;
    }
}

export default RankingStatsMapper;
